import { clsx } from "clsx";
import toast from "react-hot-toast";
import { Text } from "../components/common/typography";

type ToastTone = "success" | "error";

// One slot per tone: a new toast replaces the visible one of the same tone
// (and restarts its timer) instead of stacking another copy over the page —
// e.g. clicking "Add to cart" several times in a row.
function showToneToast(message: string, tone: ToastTone) {
  toast.custom((t) => (
    <div
      className={clsx(
        "flex h-12 min-w-[320px] max-w-[470px] items-center justify-center rounded-xl px-8 transition-all duration-200 ease-out",
        tone === "success" && "bg-accentGreenTint",
        tone === "error" && "bg-accentErrorTint",
      )}
      style={{
        transform: t.visible
          ? "translateY(0) scale(1)"
          : "translateY(-100%) scale(0.95)",
        opacity: t.visible ? 1 : 0,
      }}
      onClick={() => toast.dismiss(t.id)}
      role="status"
    >
      <Text
        variant="bodyBold"
        inline
        className={clsx(
          "text-center",
          tone === "success" && "text-accentGreenDark",
          tone === "error" && "text-accentError",
        )}
      >
        {message}
      </Text>
    </div>
  ), { id: tone });
}

export const showErrorToast = (message: string, error?: unknown) => {
  if (error !== undefined) console.error(error);
  showToneToast(message || "Something went wrong. Please try again.", "error");
};

export const showSuccessToast = (message: string) => {
  showToneToast(message, "success");
};
